import { check_product_offer } from "./availability.js";

// Seconds left until the offer of `product` ends; `undefined` when the offer has no timer or is already over.
// `now` (ms) is injectable so a ticking clock can be passed in.
export const get_offer_remaining_seconds = (product, now = new Date().getTime()) => {
  const expire_at = parseInt(product?.price?.offer_expireAt);
  const now_time = parseInt(now);
  const discount = check_product_offer(product);
  if (product?.price?.show_discount_timer && discount > 0 && expire_at > 0) {
    const remaining = expire_at / 1000 - now_time / 1000;
    return remaining > 0 ? remaining : undefined;
  }
  return undefined;
};
